import React from 'react';
import { withStyles } from '../../mui-styles-bridge.js';
import DOMPurify from 'dompurify';
import './TipTap/TipTapEditor.css';

const styles = () => ({
  root: {
    marginTop: '1rem',
  },
});

/**
 * RawText - Renders content block HTML in forms
 * 
 * Uses DOMPurify to sanitize and render raw HTML directly, preserving inline CSS
 * styles (e.g., table cell backgrounds, colors, borders, padding) that workflows
 * may generate via code components.
 * 
 * Previously used TipTap in read-only mode, which stripped inline CSS because
 * ProseMirror's schema only preserves attributes explicitly declared in extensions.
 * The tiptap-editor-content class is kept as a wrapper so base styles (table borders,
 * list padding, link colors) still apply for content that doesn't have inline CSS.
 */
class RawText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialData: {},
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      initialData: data.data,
    });
  }

  render() {
    const { data, classes } = this.props;
    
    const content = this.state.initialData !== data.data
      ? data.data
      : this.state.initialData;

    return (
      <div className={classes.root}>
        <div
          className="tiptap-editor-content"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(content || ''),
          }}
        />
      </div>
    );
  }
}

export default withStyles(styles)(RawText);
